
















import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import RuleConfig from "../model/ruleConfig";
import TagSelect from "@/components/tag-select/index.vue";
@Component({
  components: {
    TagSelect
  }
})
export default class MemberScope extends Vue {
  @Prop({
    type: Object,
    default: () => {
      return {
        memberScope: "All",
        memberTags: [],
        cumulativeWithOtherDiscount: false,
        discounts: []
      };
    }
  })
  value!: RuleConfig;
  toggle: boolean = false;
  get selectTagItems() {
    return this.value.memberTags.map(x => x.value);
  }
  onChange(e, result) {
    console.log(e, result);
    this.$forceUpdate()
    this.value.memberTags = result;
  }
  handleClose(e, name, index) {
    this.$forceUpdate()
    this.value.memberTags.splice(index, 1);
  }
  memberScopeChange(e) {
    this.$forceUpdate()
    this.value.memberTags = [];
  }
}
